import React from 'react';

const GuestMenu = () => (
  <div className="guest-notice">Для работы в системе вам необходимо авторизоваться</div>
);

export default GuestMenu;
